import React from 'react';
import OrgStakeholderFormModal from '../../components/organizations/Stakeholders/OrgStakeholderFormModal/index.jsx';
import { stakeholderTypeOptions } from './utils/stakeholdersStructure.js';

function OrgStakeholderFormContainer(props) {
  const { showFormModal, onHideFormModal, onSubmitSuccess, preselectedType } =
    props;

  return (
    <OrgStakeholderFormModal
      onSubmitSuccess={onSubmitSuccess}
      onHide={onHideFormModal}
      show={showFormModal}
      stakeholderTypeOptions={stakeholderTypeOptions}
      preselectedType={preselectedType}
    />
  );
}

export default OrgStakeholderFormContainer;
